import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
const PackageSalesCodesOnly = () => {
	//ApiData Component Content Variables
	const x = 0;
	const [positionID, setPositionID] = useState(get_cookies("position_id"));
	const [PackagesNavDetails, loadPackagesNav] = useState([]);
	const [contentNav, setContentNav] = useState("");
	const navigations = [];
	//OnLoad Event/Data Fetching
	useEffect(() => {
		get_package_navigation();
		getContentNavData();
	}, []);

	useEffect(() => {
		//
		isLoggedIn();
	}, [x]);

	//Api Functions SOF
    const get_package_navigation = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "packagesnav_co")
			.then(function (res) {
                loadPackagesNav(res.data.packagesnav_co);
			})
			.catch(function (error) {
				// console.log(error);
			});
	};

	const getContentNavData = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "get_content_nav_data", {
				params: {
					name: "sales", //
					content_nav: get_cookies("content.nav.access")
				}
			})
			.then(function (res) {
				setContentNav(res.data.data);
			})
			.catch(function (error) {
				// console.log(error);
			});
	};
	//Api Request Functions EOF
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
                <Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Package Sales (Codes Only)</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<Grid container spacing={2}>
					{PackagesNavDetails.map((value, index) => {
						// <option value={key}>{tifs[key]}</option>
						navigations.push(
							<Grid
								item
								xs={6}
								className="app-card-container"
								style={{
									"--cardBorderColor": value.nav_color
								}}
							>
								<NavLink
									to={
										"/package-sales-co-menu/" +
										value.package_code +
										"/" +
										value.name
									}
								>
									<div className="app-card">
										{value.name}
									</div>
								</NavLink>
							</Grid>
						);
					})}
					{navigations}
				</Grid>
			</div>
		</div>
	);
};

export default PackageSalesCodesOnly;
